import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
    lazyComponent: true,
    attempt: 1,
    throttleWait: 0,
    listenEvents: ['load', 'scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'],
    observer: true,
    observerOptions: {
        rootMargin: '0px',
        threshold: 0
    }
});
